export var props = {
  props: {
    type: {
      type: String,
      required: true,
      default: 'normal'
    }
  }
};